import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';

const Facebook = asyncComponent({
    resolve: () => import('./Facebook'),
});

export default class FacebookWrapper extends Component {
    render() {
        return(
            <div>
                <Facebook config={this.props.config} reportEvent={this.props.reportEvent} />
            </div>
        );
    }
}

FacebookWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
